// extracted by mini-css-extract-plugin
export default {"btns":"Signup_btns__CalrX","form":"Signup_form__5ULsQ","label":"Signup_label__FYTfY","checkbox":"Signup_checkbox__LeMhw"};